import React, { useState, useEffect } from "react";
import { useQuery, useQueryClient } from 'react-query'
import { getResultRSC_H2H } from "data/Querys"
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import ScoreHorizontal, { ScorePeriodBox } from 'components/common/ScoreHorizontal'
import Loader from 'components/general/Loader'
import { findArray, filterArray } from 'helpers/utils'
import { getSportCodeEntityObjects } from 'components/common/SportCode'
import { useViewport } from 'components/general/useViewPort'
import {
  RESULT_STATUS,
  getResultStatusAsInteger,
  isStartListStatus
} from "helpers/status";
import PageHeader from "components/common/PageHeader";
import Label from "components/general/Label";
import NotAvailable from "components/common/NotAvailable";
import SportCode from "components/common/SportCode";




//Start List
import GblStartList from "components/sports/gbl/views/GblStartList";
//Play by play
import GblPbp from "components/sports/gbl/views/GblPbp";
//Players Statistics
import GblPlayerStats from "components/sports/gbl/views/GblPlayerStats";
//Shot Chart
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";



const GblContext = () => {
  const { mirs_discipline, mirs_rsc, mirs_competition, mirs_language } = useUrlFriendlyToParameters()
  const { breakPoint } = useViewport();
  const queryClient = useQueryClient();
  const [periodsOrder, setPeriodsOrder] = useState()

  useEffect(() => {
    const dataSportCodes = queryClient.getQueryData(["SportCodes", mirs_competition, mirs_language])?.sportCodes;
    const periodsCodes = getSportCodeEntityObjects(dataSportCodes, mirs_discipline, '@Period');
    const periodsOrder_ = periodsCodes ? periodsCodes?.map(p => ({ period: p.sportCode, order: parseInt(p.order) }))?.sort((a, b) => a.order - b.order) : [];
    setPeriodsOrder(periodsOrder_)
  }, [])

  //datos para el marcador y estadisticas
  const { data, isError, isLoading } = useQuery(
    {
      queryKey: ['resultsDataH2H', mirs_competition, mirs_rsc, mirs_language],
      queryFn: getResultRSC_H2H,
      refetchInterval: 5000,
      staleTime: 5000,
      refetchIntervalInBackground: true,
      notifyOnChangeProps: ['data', 'error'],
      //enabled: !!confCategory
      onError: (error) =>
        console.error(`Something went wrong: ${error.message}`),
    });

  if (isError) { return <NotAvailable />; }
  if (isLoading || !periodsOrder) { return <Loader />; }
  if (!data?.results) { return <NotAvailable /> }

  let tabStartList = false;
  let tabDisabled = false;
  const resultStatus = data?.results?.status?.code;

  if (getResultStatusAsInteger(resultStatus) < RESULT_STATUS.START_LIST) {
    tabStartList = true;
  }
  if (getResultStatusAsInteger(resultStatus) < RESULT_STATUS.LIVE) {
    tabDisabled = true;
  }

  let score;
  let shortDescription = data?.results?.eventUnit?.description;
  let presentationGame = shortDescription;
  let numberGame = findArray(data?.results?.extendedInfos, { ei_code: ['UNIT_NUMBER'] }).ei_value;
  let currentPeriod = findArray(data?.results?.extendedInfos, { ei_code: ['PERIOD'] }).ei_value;
  if (numberGame) {
    presentationGame = <>{presentationGame} - <Label data='HeaderMatch' /> {numberGame}</>
  }

  score = <ScoreHorizontal
    data={data}
    scoreHeader={{
      left: <>{presentationGame}</>
    }}
    scoreBody={{

    }}
    scoreFooter={{
      top: <Periods data={data?.results?.periods} currentPeriod={currentPeriod} />,
    }
    }
  />

  const getConfigForReferees = () => {
    let config = {
      source: 'official',
      avoidDuplicates: true
    }
    return config
  }
  const refereesConf = getConfigForReferees();

  return (
    <>
      <PageHeader data={data} />
      <div className='mirs-page-container'>
      <div className='my-5'>
        {score}
      </div>
      <Tabs
        id="mirs-navsport"
        defaultActiveKey={isStartListStatus(resultStatus) ? `1-${mirs_rsc}` : `2-${mirs_rsc}`}
        className="mb-3 mirs-tab-result"
      >
        <Tab eventKey={`1-${mirs_rsc}`} title={(<Label data='HeaderStartList' />)} disabled={tabStartList} >
          <GblStartList data={data} />
        </Tab>
        <Tab eventKey={`2-${mirs_rsc}`} title={(<Label data='HeaderPlayByPlay' />)} disabled={tabDisabled} >
          <GblPbp data={data} periodsOrder={periodsOrder} />
        </Tab>
        <Tab eventKey={`3-${mirs_rsc}`} title={(<Label data='HeaderGameResults' />)} disabled={tabDisabled} >
          <>
            <GblPlayerStats data={data} team={1} />
            <GblPlayerStats data={data} team={2} />
          </>
        </Tab>
      </Tabs>
      </div>
    </>
  );
};

function Periods({ data, currentPeriod }) {
  const { mirs_discipline } = useUrlFriendlyToParameters()
  if (data) {
    return (
      <>
        {filterArray(data, { p_code: ['H1', 'H2', 'OT1', 'OT2'] }).map((item, index) => (
          <ScorePeriodBox
            key={'scorePeriodBlock' + index}
            periodTop={<SportCode discipline={mirs_discipline} entity='@Period' code={item.p_code} />}
            periodBottom={item.home.periodScore + ' - ' + item.away.periodScore}
            currentPeriod={currentPeriod}
            codePeriod={item.p_code} />
        ))}
      </>
    )
  }
}
export default GblContext;
